import React, { useMemo } from 'react'
import * as PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import { withMemo } from '../../decorators'
import Layout from '../../components/Layout'
import useConfiguration from '../../hooks/useConfiguration'
import CountdownTemplate from '../../templates/Countdown'
import * as appConfiguration from '../../configuration'


const Countdown = (props) => {
  const { pageContext, location, data } = props
  const { configuration, seoFallback } = useConfiguration(data)

  const layoutProps = useMemo(() => ({
    seo: {
      lang: pageContext?.language ?? null,
      title: seoFallback?.title ?? '',
      description: seoFallback?.description?.description ?? '',
      image: appConfiguration.app.url + seoFallback?.picture?.localFile?.childImageSharp?.fluid?.src ?? '',
      url: location?.href ?? '',
    },
  }), [seoFallback, location, pageContext])

  return (
    <Layout {...layoutProps}>
      <CountdownTemplate
        countDownDate={configuration?.countdown}
      />
    </Layout>
  )
}

Countdown.propTypes = {
  // eslint-disable-next-line
  data: PropTypes.object,
  // eslint-disable-next-line
  pageContext: PropTypes.object,
  // eslint-disable-next-line
  location: PropTypes.object,
}

Countdown.defaultProps = {
  data: null,
  pageContext: null,
  location: null,
}

export default withMemo()(Countdown)


export const query = graphql`
  query countdown($language: String){
    contentfulConfiguration(node_locale: { eq: $language }) {
      ...balenciageF21Configuration
    }
  }
`
